import { render, staticRenderFns } from "./sidebar-field-section.vue?vue&type=template&id=3e9e1c5e&scoped=true"
import script from "./sidebar-field-section.vue?vue&type=script&lang=js"
export * from "./sidebar-field-section.vue?vue&type=script&lang=js"
import style0 from "./sidebar-field-section.vue?vue&type=style&index=0&id=3e9e1c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9e1c5e",
  null
  
)

export default component.exports